/* eslint-disable no-console */
/* eslint-disable no-nested-ternary */

import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Grid2, Switch, Typography, Card, CardContent } from "@mui/material";
import MDBox from "components/MDBox";
import CopytoClipboard from "components/CopytoClipboard";
import ViewEditActions from "components/DetailList/ViewEditActions";
import FormField from "components/FormField";
import ServiceJobsCompanyPicker from "components/AutoComplete/ٍServiceJobs/ٍServiceJobsCompanyPicker";
import ServiceJobsSystemPicker from "components/AutoComplete/ٍServiceJobs/ServiceJobsSystemPicker";
import ServiceJobsVersionPicker from "components/AutoComplete/ٍServiceJobs/ServiceJobsVersionPicker";
import DetailList from "components/DetailList";
import PMSPicker from "components/AutoComplete/pms";
import DynamicRadioGroup from "components/DynamicRadioGroup";
import Danger from "components/Danger";
import { addJobs, setLoading } from "store/actions/locationAction";
import { getUpdatedFilter } from "store/actions/userActions";
import { Formik, Form } from "formik";
import validationsCompanion from "../schemas/validationsCompanion";
import initialValuesCompanion from "../schemas/initialValuesCompanion";
import formCompanion from "../schemas/formCompanion";

const webUrl =
  process.env.REACT_APP_ENV === "production"
    ? "https://lokalee.app"
    : "https://staging.lokalee.app";

const GuestCompanion = ({ location, selectedTab }) => {
  /* *** Selectors *** */
  const reduxFilters = useSelector((state) => state.users.filters);
  const user = useSelector((state) => state.users.user);

  /* *** Constants *** */
  const dispatch = useDispatch();
  const {
    apikey,
    url,
    portalId,
    diningId,
    // natsPropertyId,
    pmsPropertyId,
    authValue,
    clientID,
    clientSecret,
    propertyID,
  } = formCompanion.formField;

  /* *** Refs *** */
  const formRef = useRef();
  // const tableRef = createRef();

  /* *** State *** */
  const [detailPage, setDetailPage] = useState(true);
  const [showInDining, setShowInDining] = useState(false);
  const [initialValues, setInitialValues] = useState(initialValuesCompanion);

  useEffect(() => {
    dispatch(
      getUpdatedFilter({
        filters: reduxFilters?.filters,
        row_nb: reduxFilters?.row_nb,
        pageValue: reduxFilters?.pageValue,
        search: "",
      })
    );
  }, []);
  useEffect(() => {
    if (location) {
      const manipulated = {};
      manipulated.company = location.guestRequestType || "";
      manipulated.propertyCode =
        (location.guestRequestPropertyId !== "hostaway" && location.guestRequestPropertyId) || "";
      manipulated.inRoomDiningPropertyId = location.inRoomDiningPropertyId || "";
      manipulated.inRoomDining = location.inRoomDining ? location.inRoomDining : false;
      manipulated.serviceJobs = location.serviceJobs || [];
      manipulated.system = location.guestRequestType === "sky" ? "guestapp" : "servicerequest";
      manipulated.version = location.guestRequestType === "sky" ? "v1" : "v0.1";
      manipulated.title = "";
      manipulated.code = "";
      manipulated.serviceJobsObj = null;
      manipulated.showGuestCompanion = location.showGuestCompanion
        ? location.showGuestCompanion
        : false;
      manipulated.url = (location.guestRequestType !== "hostaway" && location?.skyUrl) || "";
      manipulated.apikey = (location.guestRequestType !== "hostaway" && location?.skyApikey) || "";
      manipulated.portalId = location?.skyPortalId || "";
      manipulated.diningId = location?.skyDiningId || "";
      manipulated.diningCompany = location.inRoomDiningPropertyId ? "digi" : "sky";

      manipulated.pmsType =
        location?.pmsType === "at-vision"
          ? { label: "At-vision (Opera Cloud 22, APALEO)", value: location?.pmsType }
          : {};
      manipulated.pmsPropertyId = location?.pmsPropertyID || location?.pmsPropertyId || "";
      manipulated.authValue = location?.guestCompanionAuthentication || "none";

      manipulated.clientID = location?.clientID || location?.hostawayConfig?.clientID || "";
      manipulated.clientSecret =
        location?.clientSecret || location?.hostawayConfig?.clientSecret || "";
      manipulated.propertyID = location?.propertyID || location?.hostawayConfig?.propertyID || "";

      setShowInDining(location.inRoomDining);
      setInitialValues(manipulated);
    }
  }, [location]);

  // set detail page to true when selctedTab changes
  useEffect(() => {
    setDetailPage(true);
  }, [selectedTab]);

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  const submitForm1 = async (values) => {
    await sleep(1000);
    dispatch(setLoading());
    dispatch(addJobs(location?._id, values, selectedTab));
    setDetailPage(true);
  };

  // const handleAddJob = (values, setFieldValue) => {
  // removed the functionallity of adding jobs to the guest companion table and delete job
  // };

  const authValueOptions = [
    { value: "none", label: "No Authentication (QR Code is defined per room)" },
    { value: "pms", label: "PMS" },
    { value: "grms", label: "GRMS" },
    { value: "pin", label: "PIN (Sent Via Email or Phone)" },
  ];

  return (
    <MDBox>
      <Grid2 container justifyContent="center">
        <Grid2 size={{ xs: 12, md: 12, lg: 12 }}>
          <Formik
            key={selectedTab}
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationsCompanion[selectedTab]}
            onSubmit={(values, actions) => submitForm1(values, actions)}
            innerRef={(f) => {
              formRef.current = f;
            }}
          >
            {({ values, errors, touched, setFieldValue, resetForm, submitForm }) => (
              <Form autoComplete="off">
                <Card>
                  <CardContent>
                    <MDBox>
                      <Grid2
                        container
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mb: 2 }}
                      >
                        <Grid2 />
                        <Grid2>
                          <ViewEditActions
                            detailPage={detailPage}
                            stateName="locations"
                            handleEdit={() => {
                              setDetailPage(false);
                            }}
                            handleClose={() => {
                              setDetailPage(true);
                              resetForm();
                              setFieldValue("serviceJobs", location.serviceJobs);
                            }}
                            handleSave={(event) => {
                              event.preventDefault();
                              submitForm();
                            }}
                          />
                        </Grid2>
                      </Grid2>

                      <Divider sx={{ marginY: 2 }} />

                      {/* Detail lists */}
                      {detailPage && selectedTab === 0 && (
                        <DetailList
                          data={{
                            ...(values?.showGuestCompanion && {
                              company: values?.company === "none" ? "lokalee" : values?.company,
                              propertyCode:
                                values?.propertyCode !== "hostaway" && values?.propertyCode,
                              apiKey: values?.apikey !== "hostaway" && values?.apikey,
                              url: values?.url !== "hostaway" && values?.url,
                              portalId: values?.company === "sky" && values?.portalId,
                              diningId: values?.company === "sky" && values?.diningId,
                              showGuestCompanion:
                                values?.company === "sky" && values?.showGuestCompanion,
                              ...(values?.company === "hostaway" && {
                                clientId: values?.clientID,
                                clientSecret: values?.clientSecret,
                                propertyId: values?.propertyID,
                              }),
                              ...(values?.company !== "none" && {
                                showGuestCompanion: values?.showGuestCompanion,
                              }),
                            }),
                          }}
                        />
                      )}
                      {detailPage && selectedTab === 1 && (
                        <DetailList
                          data={{
                            company: values?.inRoomDining
                              ? values?.diningCompany === "digi"
                                ? "Digi Menu"
                                : "Sky Software"
                              : "",
                            propertyCode: values?.inRoomDiningPropertyId,
                          }}
                        />
                      )}
                      {detailPage && selectedTab === 2 && (
                        <DetailList
                          data={{
                            type: values?.pmsType?.label || "--",
                            propertyId: values?.pmsPropertyId || "--",
                          }}
                        />
                      )}
                      {detailPage && selectedTab === 3 && (
                        <DetailList
                          data={{
                            authValue: values?.authValue || "none",
                          }}
                        />
                      )}

                      {/* Guest companion */}
                      {!detailPage && selectedTab === 0 && (
                        <>
                          <Typography
                            variant="h6"
                            component="div"
                            sx={{ display: "inline", mr: 2 }}
                          >
                            Guest Companion
                          </Typography>
                          <Switch
                            checked={values?.showGuestCompanion}
                            onChange={() =>
                              setFieldValue("showGuestCompanion", !values?.showGuestCompanion)
                            }
                            color="primary"
                          />

                          {values?.showGuestCompanion && (
                            <>
                              <Grid2 size={{ xs: 12 }} style={{ marginBottom: 4 }}>
                                <CopytoClipboard
                                  text={`${webUrl}/locations/${location?.slug}/companion`}
                                />
                              </Grid2>
                              <Typography style={{ fontSize: "0.875rem", fontWeight: 400 }}>
                                Choose your vendor:
                              </Typography>
                              <Grid2 container spacing={2} alignItems="center">
                                <Grid2 size={{ xs: 3 }}>
                                  <ServiceJobsCompanyPicker
                                    isDisabled={user?.role === "partner"}
                                    companyV={values?.company}
                                    setFieldValue={setFieldValue}
                                    companyOptions={[
                                      { label: "Sky Software", value: "sky" },
                                      { label: "Message Box", value: "messagebox" },
                                      { label: "Hostaway", value: "hostaway" },
                                      { label: "Lokalee", value: "none" },
                                    ]}
                                  />
                                </Grid2>

                                {values?.company !== "hostaway" && (
                                  <>
                                    <Grid2 item size={{ xs: 3 }}>
                                      <ServiceJobsSystemPicker
                                        company={values.company}
                                        systemV={values?.system}
                                        setFieldValue={setFieldValue}
                                      />
                                    </Grid2>
                                    <Grid2 item size={{ xs: 3 }}>
                                      <ServiceJobsVersionPicker
                                        company={values.company}
                                        system={values.system}
                                        versionV={values?.version}
                                        setFieldValue={setFieldValue}
                                      />
                                    </Grid2>
                                    <Grid2 item size={{ xs: 3 }}>
                                      <FormField
                                        type="text"
                                        label="Property Code"
                                        name="propertyCode"
                                        value={values?.propertyCode}
                                        placeholder="Property Code"
                                        error={errors?.propertyCode && touched?.propertyCode}
                                        success={
                                          values?.propertyCode?.length > 0 && !errors?.propertyCode
                                        }
                                        disabled={user?.role === "partner"}
                                      />
                                    </Grid2>
                                  </>
                                )}

                                {values?.company !== "hostaway" && (
                                  <Grid2 container spacing={2} alignItems="center" width="100%">
                                    <Grid2 item size={{ xs: 3 }}>
                                      <FormField
                                        type={apikey.type}
                                        name={apikey.name}
                                        label={apikey.label}
                                        value={values?.apikey}
                                        placeholder={apikey.label}
                                        disabled={user?.role === "partner"}
                                      />
                                    </Grid2>
                                    <Grid2 item size={{ xs: 9 }}>
                                      <FormField
                                        name={url.name}
                                        type={url.type}
                                        label={url.label}
                                        value={values?.url}
                                        placeholder={url.label}
                                        error={errors?.url && touched?.url}
                                        success={values?.url?.length > 0 && !errors?.url}
                                        disabled={user?.role === "partner"}
                                      />
                                    </Grid2>
                                  </Grid2>
                                )}
                              </Grid2>
                              {/* {values?.company === "sky" && (
                                <Grid2 container spacing={2} alignItems="center">
                                  <Grid2 size={{ xs: 6 }}>
                                    <FormField
                                      type={portalId.type}
                                      name={portalId.name}
                                      label={portalId.label}
                                      value={values?.portalId}
                                      placeholder={portalId.label}
                                    />
                                  </Grid2>

                                  <Grid2 size={{ xs: 6 }}>
                                    <FormField
                                      type={diningId.type}
                                      name={diningId.name}
                                      label={diningId.label}
                                      value={values?.diningId}
                                      placeholder={diningId.label}
                                    />
                                  </Grid2>
                                  <Grid2 size={{ xs: 4 }}>
                                    <FormField
                                      type={natsPropertyId.type}
                                      name={natsPropertyId.name}
                                      label={natsPropertyId.label}
                                      value={values?.natsPropertyId}
                                      placeholder={natsPropertyId.label}
                                    />
                                  </Grid2>
                                </Grid2>
                              )} */}
                              {values?.company === "sky" && (
                                <Grid2 container spacing={2} alignItems="center">
                                  <Grid2 size={{ xs: 6 }}>
                                    <FormField
                                      type={portalId.type}
                                      name={portalId.name}
                                      label={portalId.label}
                                      value={values?.portalId}
                                      placeholder={portalId.label}
                                      disabled={user?.role === "partner"}
                                    />
                                  </Grid2>

                                  <Grid2 size={{ xs: 6 }}>
                                    <FormField
                                      type={diningId.type}
                                      name={diningId.name}
                                      label={diningId.label}
                                      value={values?.diningId}
                                      placeholder={diningId.label}
                                      disabled={user?.role === "partner"}
                                    />
                                  </Grid2>
                                </Grid2>
                              )}
                              {/* Addtional fields for Hostaway */}
                              {values?.company === "hostaway" && (
                                <Grid2 container spacing={2} alignItems="center" marginTop={3}>
                                  <Grid2 size={{ xs: 4 }}>
                                    <FormField
                                      type={clientID.type}
                                      name={clientID.name}
                                      label={clientID.label}
                                      value={values?.clientID}
                                      placeholder={clientID.label}
                                      disabled={user?.role === "partner"}
                                    />
                                  </Grid2>
                                  <Grid2 item size={{ xs: 4 }}>
                                    <FormField
                                      type={clientSecret.type}
                                      name={clientSecret.name}
                                      label={clientSecret.label}
                                      value={values?.clientSecret}
                                      placeholder={clientSecret.label}
                                      disabled={user?.role === "partner"}
                                    />
                                  </Grid2>
                                  <Grid2 item size={{ xs: 4 }}>
                                    <FormField
                                      type={propertyID.type}
                                      name={propertyID.name}
                                      label={propertyID.label}
                                      value={values?.propertyID}
                                      placeholder={propertyID.label}
                                      disabled={user?.role === "partner"}
                                    />
                                  </Grid2>
                                </Grid2>
                              )}
                            </>
                          )}
                        </>
                      )}

                      {/* In room dining */}
                      {!detailPage && selectedTab === 1 && (
                        <>
                          <Grid2>
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{ display: "inline", mr: 2 }}
                            >
                              In Room Dining
                            </Typography>

                            <Switch
                              disabled={user?.role === "partner"}
                              color="primary"
                              checked={showInDining}
                              onChange={() => {
                                setShowInDining(!showInDining);
                                setFieldValue("inRoomDining", !values?.inRoomDining);
                              }}
                            />
                          </Grid2>

                          {showInDining && (
                            <Grid2 container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                              <Grid2 size={{ xs: 3 }}>
                                <ServiceJobsCompanyPicker
                                  isDisabled={user?.role === "partner"}
                                  isDiningTab
                                  setFieldValue={setFieldValue}
                                  companyV={values?.diningCompany}
                                  companyOptions={[
                                    { label: "Digi Menu", value: "digi" },
                                    { label: "Sky Software", value: "sky" },
                                  ]}
                                />
                              </Grid2>

                              <Grid2 size={{ xs: 3 }}>
                                <ServiceJobsSystemPicker
                                  setFieldValue={setFieldValue}
                                  company={values.diningCompany}
                                  systemV={values?.diningSystem}
                                />
                              </Grid2>

                              <Grid2 size={{ xs: 3 }}>
                                <ServiceJobsVersionPicker
                                  setFieldValue={setFieldValue}
                                  company={values.diningCompany}
                                  versionV={values?.diningVersion}
                                />
                              </Grid2>

                              {values?.diningCompany === "digi" && (
                                <Grid2 size={{ xs: 3 }}>
                                  <FormField
                                    type="text"
                                    label="Property Code"
                                    placeholder="Property Code"
                                    name="inRoomDiningPropertyId"
                                    value={values?.inRoomDiningPropertyId}
                                    error={
                                      errors?.inRoomDiningPropertyId &&
                                      touched?.inRoomDiningPropertyId
                                    }
                                    success={
                                      values?.inRoomDiningPropertyId?.length > 0 &&
                                      !errors?.inRoomDiningPropertyId
                                    }
                                    disabled={user?.role === "partner"}
                                  />
                                </Grid2>
                              )}
                            </Grid2>
                          )}
                        </>
                      )}

                      {/* PMS */}
                      {!detailPage && selectedTab === 2 && (
                        <Grid2 container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                          <Grid2 item size={{ xs: 6 }}>
                            <PMSPicker
                              setFieldValue={setFieldValue}
                              pmsTypeV={values?.pmsType}
                              companyOptions={[
                                { label: "At-vision (Opera Cloud 22, APALEO)", value: "at-vision" },
                              ]}
                            />
                            {errors?.pmsType && <Danger validation={errors?.pmsType} />}
                          </Grid2>

                          <Grid2 item size={{ xs: 6 }}>
                            <FormField
                              type={pmsPropertyId.type}
                              label={pmsPropertyId.label}
                              placeholder="Property Id"
                              name={pmsPropertyId.name}
                              value={values?.pmsPropertyId}
                              error={errors?.pmsPropertyId && touched?.pmsPropertyId}
                              success={values?.pmsPropertyId?.length > 0 && !errors?.pmsPropertyId}
                            />
                          </Grid2>
                        </Grid2>
                      )}

                      {/* User Authentication */}
                      {!detailPage && selectedTab === 3 && (
                        <Grid2 container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                          <Grid2
                            item
                            size={{ xs: 12 }}
                            sx={{ display: "flex", flexDirection: "column" }}
                          >
                            <div>
                              <DynamicRadioGroup
                                // groupLabel={authValue.label}
                                name={authValue.name}
                                value={values?.authValue}
                                options={authValueOptions}
                                setFieldValue={setFieldValue}
                              />
                            </div>
                          </Grid2>
                        </Grid2>
                      )}
                    </MDBox>
                  </CardContent>
                </Card>
              </Form>
            )}
          </Formik>
        </Grid2>
      </Grid2>
    </MDBox>
  );
};

GuestCompanion.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  selectedTab: PropTypes.number.isRequired,
};

export default GuestCompanion;
